/* eslint-disable prettier/prettier */
/**
 * 公共方法
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ContactsFilterFlag, SearchType, UserTypeEnum, } from './types';
import { isEmpty, omit, omitBy } from 'lodash';
import React, { useState } from 'react';
import getHighlightComp, { getHighlightCompWithLabel, getTelHighlightComp } from '../utils';
import server from '../server/index';
import orgAvatarPng from '../images/default_dept_avatar.png';
import workLineAvatarPng from '../images/default_virtual_avatar.png';
// /userType目前只有三种类型：1.外部、2.未认证、3.正式 4.跨租户、5.跨平台
// /此方法主要用来筛选联系人选择器的人员数据
function ContactSelectorShowType(type, item, currentUser) {
    var _a, _b, _c, _d;
    var innerSameTeam = 1 << 0; // 同租户 内部人员 1
    var innerSameTeamExternal = 1 << 1; // 同租户 外部人员（userType类型不同）2
    var crossTeam = 1 << 2; // 不同租户的人员，也称为 外部人员 4
    var crossPlatform = 1 << 3; // 不同应用的，如京 me 和行业版  appId 不同 8
    var sameTenement = innerSameTeam | innerSameTeamExternal; // 同租户内部人员、同租户的外部人员  1|2   3
    var multiTenement = innerSameTeam | innerSameTeamExternal | crossTeam; // 同租户内部人员、同租户的外部人员、不同租户的人员  1|2|4   7
    var crossTeamAndCrossPlatform = crossTeam | crossPlatform; // 不同应用的、不同租户的人员  4|8   12
    var all = innerSameTeam | innerSameTeamExternal | crossTeam | crossPlatform; // 所有类型人员   1|2|4|8   15
    var app = item.app || ((_b = (_a = item.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.app);
    var teamId = item.teamId || ((_d = (_c = item.origin) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.teamId);
    var userType = item.userType;
    if (!type || !app || !teamId)
        return false;
    if ((type & crossPlatform) > 0 && filterCrossPlatformCondition(app, userType, currentUser)) {
        // console.log(
        //     111,
        //     12 & 8,
        //     userType,
        //     filterCrossPlatformCondition(app, userType, currentUser),
        //     '1跨平台'
        // );
        return true;
    }
    if ((type & crossTeam) > 0 && filterCrossTeamCondition(app, teamId, userType, currentUser)) {
        // console.log(
        //     2222,
        //     12 & 4,
        //     userType,
        //     filterCrossTeamCondition(app, teamId, userType, currentUser),
        //     '1跨租户'
        // );
        return true;
    }
    if ((type & innerSameTeamExternal) > 0 && filterSameTeamCondition(item, currentUser)) {
        // console.log(3333, 12 & 2, userType, filterSameTeamCondition(item, currentUser), '1外部');
        return true;
    }
    if ((type & innerSameTeam) > 0 &&
        filterSameTeamAndUnCertify(app, teamId, userType, currentUser)) {
        // console.log(444, 12 & 1, userType,filterSameTeamAndUnCertify(app, teamId, userType, currentUser), '正式/未认证');
        return true;
    }
    return false;
}
function ContactSelectGroupType(type, kind, subKind) {
    var innerGroup = 1 << 0; // 内部组  1
    var crossTenement = 1 << 1; // 跨租户组  2
    var crossPlatform = 1 << 2; // 跨平台组   4
    var innerAndCrossTenement = innerGroup | crossTenement; // 内部组和跨租户组   1|2 3
    var innerAndCrossPlatform = innerGroup | crossPlatform; // 内部组和跨平台组   1|4 5
    var all = innerGroup | crossTenement | crossPlatform; // 所有类型的组  1|2|4  7
    // /返回当前群是否展示
    // /type: 需要展示的群类型
    // /kind：当前群的类型(512:内部群，1024:外部群)
    // /subKind：3 跨平台群, 6 跨租户群
    if (type === null || kind === null)
        return false;
    // (3&4) > 0
    if ((type & crossPlatform) > 0 && kind === 1024 && subKind === 3) {
        // console.log(111, 3 & 4, '跨平台组');
        return true;
    }
    // (3&2) > 0
    if ((type & crossTenement) > 0 && kind === 1024 && subKind === 6) {
        // console.log(222, 3 & 2, '跨租户组');
        return true;
    }
    // (3&1) > 0
    if ((type & innerGroup) > 0 && kind === 512) {
        // console.log(333, 3 & 1, '内部组');
        return true;
    }
    return false;
}
export function selectGroupTypeListItem(selectGroupType, data) {
    if (!selectGroupType) {
        return data;
    }
    return data.filter(function (item) {
        return ContactSelectGroupType(selectGroupType, item.kind, item.subKind);
    });
}
export function selectContactTypeListItem(contactShowType, data, currentUser) {
    if (!contactShowType) {
        return data;
    }
    return data.filter(function (item) {
        return ContactSelectorShowType(contactShowType, item, currentUser);
    });
}
// eslint-disable-next-line max-params
export function contactAndGroupListItem(contactShowType, selectGroupType, contacts, currentUser) {
    var data = contacts.reduce(function (result, item) {
        if (selectGroupType &&
            (item.groupId || item.gid) &&
            ContactSelectGroupType(selectGroupType, item.kind, item.subKind)) {
            result.push(item);
        }
        else if (contactShowType && ContactSelectorShowType(contactShowType, item, currentUser)) {
            result.push(item);
        }
        else if (item.isCustomDept) {
            // 增加isCustomGroup和isCustomDept是为了适配自定义tab 可以传入部门不需要考虑跨平台跨租户问题
            result.push(item);
        }
        return result;
    }, []);
    return data;
}
// 过滤外部联系人标签
export function contactsListData(contactsFilterFlag, contacts, currentUser) {
    var dataList = contacts || [];
    if (!contactsFilterFlag || !contactsFilterFlag.length) {
        return dataList;
    }
    contactsFilterFlag.forEach(function (item) {
        // if (item === ContactsFilterFlag.all) {
        //     dataList = contacts;
        // }
        if (item === ContactsFilterFlag.sameTeam) {
            // 过滤同团队用户
            dataList = filterSameTeamListItem(currentUser, dataList);
        }
        if (item === ContactsFilterFlag.crossPlatform) {
            // 过滤跨平台的外部联系人用户
            dataList = filterCrossPlatformListItem(currentUser, dataList);
        }
        if (item === ContactsFilterFlag.crossTeam) {
            // 过滤同平台的不同团队外部联系人用户
            dataList = filterCrossTeamListItem(currentUser, dataList);
        }
    });
    return dataList;
    // if (!contacts || !contacts.length) {
    //     return [];
    // } else if (!contactsFilterFlag || contactsFilterFlag === ContactsFilterFlag.all) {
    //     return contacts || [];
    // } else if (contactsFilterFlag === ContactsFilterFlag.crossPlatform) {
    //     // 过滤跨平台的外部联系人用户
    //     return filterCrossPlatformContacts(currentUser, contacts) || [];
    // } else if (contactsFilterFlag === ContactsFilterFlag.external) {
    //     // 过滤同平台的不同团队外部联系人用户
    //     return filterCrossTeamContacts(currentUser, contacts) || [];
    // } else {
    //     return [];
    // }
}
// 是否本团队的外部联系人
// eslint-disable-next-line max-params
export function filterSameTeamCondition(data, currentUser) {
    var _a, _b, _c, _d;
    var userType = data.userType, labelInfoList = data.labelInfoList;
    var app = data.app || ((_b = (_a = data.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.app);
    var teamId = data.teamId || ((_d = (_c = data.origin) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.teamId);
    var externalTag;
    if (labelInfoList && labelInfoList.length > 0) {
        externalTag =
            labelInfoList.filter(function (item) { return item.label === 'isExternal' && item.isShow === '1'; })
                .length > 0;
    }
    else {
        externalTag = false;
    }
    // return app === currentUser.app && teamId === currentUser.teamId;
    return userType
        ? userType === UserTypeEnum.external
        : externalTag && app === currentUser.app && teamId === currentUser.teamId;
}
// 是否本团队正式用户或者未认证用户
// eslint-disable-next-line max-params
export function filterSameTeamAndUnCertify(app, teamId, userType, currentUser) {
    return userType
        ? userType === UserTypeEnum.formal || userType === UserTypeEnum.unCertify
        : app === currentUser.app && teamId === currentUser.teamId;
}
// 是否跨平台联系人
export function filterCrossPlatformCondition(app, userType, currentUser) {
    // return app !== currentUser.app ;
    return userType ? userType === UserTypeEnum.crossPlatform : app !== currentUser.app;
}
// 是否跨租户外部联系人
// eslint-disable-next-line max-params
export function filterCrossTeamCondition(app, teamId, userType, currentUser) {
    return userType
        ? userType === UserTypeEnum.crossTeam
        : app === currentUser.app && teamId !== currentUser.teamId;
}
// // 过滤跨平台的搜索联系人结果
// export function filterCrossPlatformContacts(
//     currentUser: UID,
//     contacts: ContactInfo[]
// ): ContactInfo[] {
//     return contacts.filter((item) => {
//         const { app, teamId } = item;
//         return !filterCrossPlatformCondition(app, teamId, item.userType, currentUser);
//     });
// }
// // 过滤外部的搜索联系人结果
// export function filterCrossTeamContacts(currentUser: UID, contacts: ContactInfo[]): ContactInfo[] {
//     return contacts.filter((item) => {
//         return !filterCrossTeamCondition(item.app, item.teamId, item.userType, currentUser);
//     });
// }
// 过滤本团队的
export function filterExternalGroupListItem(currentUser, data) {
    return data.filter(function (item) {
        return !filterSameTeamCondition(item, currentUser);
    });
}
// 过滤本团队的
export function filterSameTeamListItem(currentUser, data) {
    return data.filter(function (item) {
        return !filterSameTeamCondition(item, currentUser);
    });
}
// 过滤跨平台的tab列表
export function filterCrossPlatformListItem(currentUser, data) {
    return data.filter(function (item) {
        var _a, _b;
        var app = item.app || ((_b = (_a = item.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.app);
        return !filterCrossPlatformCondition(app, item.userType, currentUser);
    });
}
// 过滤跨租户的tab列表
export function filterCrossTeamListItem(currentUser, data) {
    return data.filter(function (item) {
        var _a, _b, _c, _d;
        var app = item.app || ((_b = (_a = item.origin) === null || _a === void 0 ? void 0 : _a.info) === null || _b === void 0 ? void 0 : _b.app);
        var teamId = item.teamId || ((_d = (_c = item.origin) === null || _c === void 0 ? void 0 : _c.info) === null || _d === void 0 ? void 0 : _d.teamId);
        return !filterCrossTeamCondition(app, teamId, item.userType, currentUser);
    });
}
export function getDeptCrumbList(data) {
    var simpleDeptInfoList = data.simpleDeptInfoList;
    if (!simpleDeptInfoList || simpleDeptInfoList.length === 0) {
        return [];
    }
    // simpleDeptInfoList.sort((a, b) => a.deptOrder - b.deptOrder);
    return simpleDeptInfoList.map(function (item) { return ({ name: item.deptName, path: item.deptId }); });
}
export function getItemChecked(itemList, id) {
    return !!itemList.find(function (item) { return item.id === id; });
}
export function getItemDisabled(frozenIds, id) {
    return frozenIds.findIndex(function (frozenIdsId) { return frozenIdsId === id; }) >= 0;
}
export function getUserInfoId(useInfo) {
    return useInfo.userId + ":" + useInfo.appId + ":" + useInfo.teamId;
}
export function getWorkLineId(data) {
    return data.nodeId;
}
export function mapTagUserInfo(list, result, frozenIds) {
    return list.map(function (info) {
        var _a;
        var id = info.userId + ":" + info.appId + ":" + info.teamId;
        var avatar = info.fields.find(function (i) { return i.key === 'avatar'; }).val;
        var name = info.fields.find(function (i) { return i.key === 'name'; }).val;
        return __assign(__assign({}, info), { id: id, app: info.appId, avatar: avatar,
            name: name, desc: getDeptPositionDesc({
                deptName: info.partTimeTitleDeptInfo[0].deptName || '',
                titleName: info.partTimeTitleDeptInfo[0].titleName || '',
                unitName: ((_a = info.partTimeTitleDeptInfo[0]) === null || _a === void 0 ? void 0 : _a.unitName) || '',
                userType: info.userType,
            }), origin: {
                info: info,
                uid: {
                    pin: info.userId,
                    userId: info.userId,
                    teamId: info.teamId,
                    app: info.appId,
                },
            }, checked: getItemChecked(result, id), disabled: getItemDisabled(frozenIds, id) || null });
    });
}
// eslint-disable-next-line max-params
export function mapGroupUserInfo(list, ItemGroup, result, frozenIds) {
    return list.map(function (useInfo) {
        var info = useInfo.info, user = useInfo.user;
        var id = info.userId + ":" + info.app + ":" + info.teamId;
        return __assign(__assign({}, user), { id: id, accountType: info.accountType, name: info.name, avatar: info.avatar, checked: getItemChecked(result, id), desc: user.desc, groupId: ItemGroup.id, groupName: ItemGroup.name, groupAvatar: ItemGroup.avatar, origin: __assign(__assign({ info: info }, user), { uid: {
                    app: info.app,
                    pin: info.userId,
                    teamId: info.teamId,
                } }), labelInfoList: user.labelInfoList || [], disabled: getItemDisabled(frozenIds, id) || null, unitName: user.unitName || '', titleName: user.titleName || '', deptName: user.deptName || '', deptId: user.deptId || '', unitDeptId: user.unitDeptId || '', userType: user.userType });
    });
}
export function mapCustomTabListInfo(contactsList, result, frozenIds) {
    return (contactsList || []).map(function (contactInfo) {
        var id = contactInfo.id ||
            contactInfo.userId + ":" + (contactInfo.app || contactInfo.appId) + ":" + contactInfo.teamId;
        return __assign(__assign({}, contactInfo), { id: id, checked: getItemChecked(result, id), disabled: getItemDisabled(frozenIds, id) || null });
    });
}
export function mapContactsUserInfo(contactsList, result, frozenIds) {
    return (contactsList || []).map(function (contactInfo) {
        var userId = contactInfo.userId, name = contactInfo.name, avatar = contactInfo.avatar, highlight = contactInfo.highlight, app = contactInfo.app, teamId = contactInfo.teamId, desc = contactInfo.desc, labelInfoList = contactInfo.labelInfoList, id = contactInfo.id;
        // const id = `${userId}:${app}:${teamId}`;
        return __assign(__assign({}, contactInfo), { id: id,
            name: name, displayName: name, avatar: avatar,
            app: app, pin: userId, teamId: teamId,
            desc: desc, origin: {
                info: contactInfo,
                uid: {
                    pin: userId,
                    userId: userId,
                    teamId: teamId,
                    app: app,
                },
            }, labelInfoList: labelInfoList || [], checked: getItemChecked(result, id), disabled: getItemDisabled(frozenIds, id) || null, userType: contactInfo.userType });
    });
}
export function mapEBookDeptInfo(list, result, canSelectDept) {
    return list.map(function (subDept) {
        var deptId = subDept.deptId, deptName = subDept.deptName;
        // const avatar = (
        //     <div className="focus-user-selection-dept-avatar">
        //         <img src={subDept.nodeType === '1' ? workLineIcon : orgIcon} alt="" />
        //     </div>
        // );
        var avatar = subDept.nodeType === '1' ? workLineAvatarPng : orgAvatarPng;
        var itemData = __assign(__assign({}, subDept), { isDept: true, id: deptId, name: deptName, avatar: avatar, 
            // desc: contactNumber + t('userSelection.people'),
            desc: '' });
        if (canSelectDept) {
            itemData.checked = getItemChecked(result, deptId);
            itemData.origin = subDept;
        }
        return itemData;
    });
}
export function mapEBookWorkLineInfo(list, result, canSelectDept) {
    return list.map(function (subDept) {
        var name = subDept.name, nodeId = subDept.nodeId;
        // const avatar = (
        //     <div className="focus-user-selection-dept-avatar">
        //         <img src={workLineIcon} alt="" />
        //     </div>
        // );
        var avatar = workLineAvatarPng;
        var itemData = __assign(__assign({}, subDept), { isWorkLine: true, id: "" + nodeId, name: name, avatar: avatar, 
            // desc: contactNumber + t('userSelection.people'),
            desc: '' });
        if (canSelectDept) {
            itemData.checked = getItemChecked(result, nodeId);
            itemData.origin = subDept;
        }
        return itemData;
    });
}
export function mapEBookDeptUserInfo(list, result, frozenIds) {
    var data = (list || {}).ebookInfoResList;
    return (data || []).map(function (useInfo) {
        var userId = useInfo.userId, name = useInfo.realName, avatar = useInfo.avatar, positionName = useInfo.positionName, appId = useInfo.appId, teamId = useInfo.teamId, isLeader = useInfo.isLeader, administratorType = useInfo.administratorType, labelInfoList = useInfo.labelInfoList;
        var id = getUserInfoId(useInfo);
        return __assign(__assign({}, useInfo), { id: id,
            name: name,
            avatar: avatar, checked: getItemChecked(result, id), desc: positionName, origin: {
                info: useInfo,
                uid: {
                    app: appId,
                    pin: userId,
                    teamId: teamId,
                },
            }, isLeader: isLeader, administratorType: administratorType, labelInfoList: labelInfoList || [], disabled: getItemDisabled(frozenIds, id) || null, deptId: list.deptId, deptName: list.deptName, fullName: list.fullName, fullPath: list.fullPath, unitDeptId: list.unitDeptId, unitName: list.unitName, titleName: positionName });
    });
}
export function mapEBookWorkLineUserInfo(list, result, frozenIds) {
    var data = (list || {}).emplList;
    return (data || []).map(function (useInfo) {
        var appId = useInfo.appId, enable = useInfo.enable, isExternal = useInfo.isExternal, labelInfoList = useInfo.labelInfoList, positionName = useInfo.positionName, realName = useInfo.realName, sortNum = useInfo.sortNum, teamId = useInfo.teamId, userId = useInfo.userId, avatar = useInfo.avatar, userType = useInfo.userType, workStatus = useInfo.workStatus, unitName = useInfo.unitName, deptName = useInfo.deptName;
        var id = getUserInfoId(useInfo);
        var desc = positionName;
        if (unitName && deptName) {
            if (unitName === deptName) {
                desc = deptName + "-" + positionName;
            }
            else {
                desc = unitName + "-" + deptName + "-" + positionName;
            }
        }
        return __assign(__assign({}, useInfo), { id: id, name: realName, avatar: avatar || '', checked: getItemChecked(result, id), desc: desc, origin: {
                info: useInfo,
                uid: {
                    app: appId,
                    pin: userId,
                    teamId: teamId,
                },
            }, labelInfoList: labelInfoList || [], disabled: getItemDisabled(frozenIds, id) || null });
    });
}
// eslint-disable-next-line max-params
export function mapSearchContacts(contactsList, result, frozenIds, keyWord) {
    return contactsList.map(function (contactInfo) {
        var userId = contactInfo.userId, name = contactInfo.realName, avatar = contactInfo.avatar, highlight = contactInfo.highlight, app = contactInfo.app, teamId = contactInfo.teamId, descValue = contactInfo.desc, labelInfoList = contactInfo.labelInfoList, deptName = contactInfo.deptName, titleName = contactInfo.titleName, unitName = contactInfo.unitName, deptId = contactInfo.deptId, unitDeptId = contactInfo.unitDeptId, remark = contactInfo.remark, ebookTag = contactInfo.ebookTag;
        var id = userId + ":" + app + ":" + teamId;
        var descHighlight = [{ key: keyWord, name: 'desc', value: descValue }];
        var remarkHighlight = [{ key: keyWord, name: 'remark', value: remark }];
        var telHighlight = highlight.find(function (i) { return i.name === 'titleList.telephone'; });
        var desc = keyWord && descValue ? getHighlightComp(descHighlight, 'desc', descValue) : descValue;
        var tagHighlight = ebookTag
            ? highlight.find(function (h) { return h.name === 'ebookTags.tag' && h.value === ebookTag; })
            : '';
        var highlightTag = tagHighlight
            ? getHighlightCompWithLabel('分组', tagHighlight, 'ebookTags.tag')
            : '';
        var remarkComps = [];
        if (remark) {
            remarkComps.push(getHighlightComp(remarkHighlight, 'remark', remark));
        }
        if (telHighlight) {
            if (remarkComps.length) {
                remarkComps.push(')(');
            }
            remarkComps.push(getTelHighlightComp(telHighlight));
        }
        return __assign(__assign({}, contactInfo), { id: id, name: getHighlightComp(highlight, 'realName', name), remark: remarkComps, realRemark: remark, displayName: name, avatar: avatar,
            app: app, pin: userId, teamId: teamId, realDesc: descValue, desc: highlightTag ? highlightTag : desc, origin: {
                info: contactInfo,
                uid: {
                    pin: userId,
                    userId: userId,
                    teamId: teamId,
                    app: app,
                },
            }, labelInfoList: labelInfoList || [], checked: getItemChecked(result, id), disabled: getItemDisabled(frozenIds, id) || null, unitName: unitName,
            deptName: deptName,
            titleName: titleName,
            deptId: deptId,
            unitDeptId: unitDeptId });
    });
}
var letters = '*abcdefghijklmnopqrstuvwxyz#'.split('');
export function groupListItem(list) {
    if ((list || []).length === 0) {
        return {};
    }
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    var pinyin = require('pinyin-pro').pinyin;
    var letterItemsMap = letters.reduce(function (result, letter) {
        result[letter] = [];
        return result;
    }, {});
    var newList = list.map(function (item) {
        return __assign(__assign({}, item), { 
            // pinName: pinyin.getFullChars(item.name).toLowerCase(),
            pinName: pinyin(item.name).toLowerCase() });
    });
    newList.sort(function (a, b) { return a.pinName.localeCompare(b.pinName, 'zh'); }); // a~z 排序
    for (var _i = 0, newList_1 = newList; _i < newList_1.length; _i++) {
        var item = newList_1[_i];
        var letter = item.pinName.charAt(0);
        if (!letters.includes(letter)) {
            letter = '#';
        }
        if (letterItemsMap.hasOwnProperty(letter)) {
            letterItemsMap[letter].push(item);
        }
        else {
            letterItemsMap[letter] = [item];
        }
    }
    // 去掉值为空数组的项
    return omitBy(letterItemsMap, isEmpty);
}
export function LetterHeader(_a) {
    var title = _a.title;
    return (React.createElement("div", { className: "data-list-container-item-group-header", id: "letter_" + title }, title.toUpperCase()));
}
export function HeaderPreviewer(_a) {
    var letters = _a.letters;
    var _b = useState(''), activeLetter = _b[0], setActiveLetter = _b[1];
    var letterClick = function (letter) {
        setActiveLetter(letter);
        var ele = document.getElementById("letter_" + letter);
        if (ele) {
            ele.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'nearest',
            });
        }
    };
    return (React.createElement("div", { className: "data-list-container-header-previewer" },
        React.createElement("div", null, letters.map(function (letter) {
            return (React.createElement("div", { key: letter, onClick: letterClick.bind(null, letter), className: activeLetter === letter ? 'activeLetter' : null }, letter.toUpperCase()));
        }))));
}
export function filterSearchGroups(groups, frozenIds, result) {
    if (!groups || !groups.length) {
        return [];
    }
    return (groups || []).map(function (item) {
        var groupId = item.groupId, groupName = item.groupName, avatar = item.avatar, highlight = item.highlight, isGroup = item.isGroup, rosterSize = item.rosterSize, kind = item.kind, subKind = item.subKind;
        var id = item.id || item.groupId;
        var freeze = (frozenIds || []).findIndex(function (a) { return a === id; }) >= 0;
        return __assign(__assign({}, item), { id: groupId, name: getHighlightComp(highlight, 'groupName', groupName), displayName: groupName, avatar: avatar, origin: item, desc: (item.groupUserCount || 0) + '人' || '', kind: kind,
            subKind: subKind,
            groupId: groupId,
            groupName: groupName, isGroup: true, checked: freeze || (result || []).findIndex(function (b) { return b.id === id; }) >= 0, highlight: highlight });
    });
}
// eslint-disable-next-line max-params
export function filterSearchDepts(depts, result, selectDept, frozenIds) {
    if (!depts || !depts.data.length) {
        return [];
    }
    return depts.data.map(function (item) {
        // const avatar = (
        //     <div className="focus-user-selection-dept-avatar">
        //         <img src={item.nodeType === '1' ? workLineIcon : orgIcon} alt="" />
        //     </div>
        // );
        var avatar = item.nodeType === '1' ? workLineAvatarPng : orgAvatarPng;
        var filterHighlight = item.highlight.length > 0
            ? item.highlight.map(function (item) {
                if (item.name === 'fullName') {
                    return __assign(__assign({}, item), { name: 'realFullName', key: item.key.split(',')[0] || item.key });
                }
                return item;
            })
            : item.realFullName;
        var desc = item.highlight.length === 0 ||
            item.highlight.findIndex(function (a) { return a.name === 'deptName'; }) >= 0
            ? item.realFullName
            : getHighlightComp(filterHighlight, 'realFullName', item.realFullName);
        var itemData = {
            id: item.deptId,
            isWorkLine: item.nodeType === '1',
            deptId: item.deptId,
            deptName: item.deptName,
            name: getHighlightComp(item.highlight, 'deptName', item.deptName),
            displayName: item.deptName,
            avatar: avatar,
            searchKey: SearchType.Department,
            title: item.deptName,
            key: item.deptId,
            fullPath: item.fullPath,
            fullName: item.fullName,
            desc: desc,
            isDept: true,
        };
        if (selectDept) {
            itemData.checked = getItemChecked(result, item.deptId);
            itemData.disabled = getItemDisabled(frozenIds, item.deptId);
        }
        return itemData;
    });
}
// eslint-disable-next-line max-params
export function getDeptPositionDesc(_a) {
    var deptName = _a.deptName, titleName = _a.titleName, userId = _a.userId, currentEmployee = _a.currentEmployee, unitName = _a.unitName, userType = _a.userType;
    var desc;
    var e_dept_full_name = deptName;
    var e_position = titleName;
    // 唤起联系人选择器不显示当前账户自己的部门和岗位信息
    if (userId && currentEmployee && userId === currentEmployee.userId) {
        e_dept_full_name = currentEmployee.e_dept_full_name || '';
        e_position = currentEmployee.e_position || '';
    }
    if (userType === '1') {
        desc = e_position;
    }
    else if (e_dept_full_name === null || e_dept_full_name === void 0 ? void 0 : e_dept_full_name.includes('-')) {
        desc = e_dept_full_name.split('-').pop() + '-' + e_position;
    }
    else if (e_dept_full_name && !(e_dept_full_name === null || e_dept_full_name === void 0 ? void 0 : e_dept_full_name.includes('-')) && e_position) {
        desc = e_dept_full_name + '-' + e_position;
    }
    else if (!e_dept_full_name && e_position) {
        desc = e_position;
    }
    else if (e_dept_full_name && !e_position) {
        desc = e_dept_full_name + '-暂无岗位';
    }
    else {
        desc = '暂未填写';
    }
    desc = unitName && deptName !== unitName ? unitName + '-' + desc : desc;
    return desc;
}
export function getWebExternalContacts(options) {
    return __awaiter(this, void 0, void 0, function () {
        var data, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, server.ebook.getExternalContacts(options)];
                case 1:
                    data = _a.sent();
                    console.log('getWebEbookDeptInfo------', data);
                    result = (data.contacts || []).map(function (item) {
                        var _a;
                        var teamId = item.openTeamId;
                        var userId = item.openUserId;
                        var id = userId + ":" + item.appId + ":" + teamId;
                        var avatar = item.fields.find(function (i) { return i.key === 'avatar'; }).val;
                        var name = item.fields.find(function (i) { return i.key === 'name'; }).val;
                        return omit(__assign(__assign({}, item), { teamId: teamId,
                            userId: userId,
                            id: id,
                            name: name, displayName: name, avatar: avatar, app: item.appId, pin: userId, desc: getDeptPositionDesc({
                                deptName: item.partTimeTitleDeptInfo[0].deptName || '',
                                titleName: item.partTimeTitleDeptInfo[0].titleName || '',
                                unitName: ((_a = item.partTimeTitleDeptInfo[0]) === null || _a === void 0 ? void 0 : _a.unitName) || '',
                                userType: item.userType,
                            }), labelInfoList: item.labelInfoList || [] }), ['openTeamId', 'openUserId']);
                    });
                    console.log(result, 'resultresultresult');
                    return [2 /*return*/, result];
            }
        });
    });
}
export function getWebSearchGlobal(options) {
    return __awaiter(this, void 0, void 0, function () {
        var data, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, server.ebook.getSearchGlobal(options)];
                case 1:
                    data = _a.sent();
                    result = __assign(__assign({}, data), { contacts: (data.contacts || []).map(function (item) {
                            return omit(__assign(__assign({}, item), { userId: item.openUserId, teamId: item.openTeamId, name: item.realName, desc: getDeptPositionDesc({
                                    deptName: item.deptName || '',
                                    titleName: item.titleName || '',
                                    unitName: (item === null || item === void 0 ? void 0 : item.unitName) || '',
                                    userType: item.userType || '',
                                }), highlight: item.highlight, realName: item.realName, unitName: item.unitName || '', titleName: item.titleName || '', deptName: item.deptName || '', deptId: item.deptId || '', unitDeptId: item.unitDeptId || '' }), ['openUserId', 'openTeamId']);
                        }) || [], depts: (data.depts && data.depts[0]) || {}, groups: data.groups || [] });
                    return [2 /*return*/, result];
            }
        });
    });
}
export function getWebEbookDeptInfo(options) {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, server.ebook.getEbookDeptInfo(options)];
                case 1:
                    data = _a.sent();
                    return [2 /*return*/, __assign(__assign({}, data), { ebookInfoResList: data.ebookInfoResList.map(function (n) {
                                return omit(__assign(__assign({}, n), { userId: n.openUserId, teamId: n.openTeamId }), ['openTeamId', 'openUserId']);
                            }) })];
            }
        });
    });
}
export function openChangeUser(data) {
    if (!data || !(data === null || data === void 0 ? void 0 : data.length)) {
        return [];
    }
    // const avatarNode = (
    //     <div className="focus-user-selection-dept-avatar">
    //         <img src={orgIcon} alt="" />
    //     </div>
    // );
    return data.map(function (item) {
        return __assign(__assign({}, item), { userId: item.openUserId, teamId: item.openTeamId, avatar: item.openUserId && item.openTeamId ? item.avatar : orgAvatarPng, id: item.openUserId && item.openTeamId && item.app
                ? item.openUserId + ":" + item.app + ":" + item.openTeamId
                : item.groupId || item.deptId || '' });
    });
}
export function mapSearchCustomMember(data) {
    return data.map(function (item) {
        var obj = __assign(__assign(__assign({}, item), (item.origin && item.origin.info)), { app: item.app || item.appId, userId: item.userId, teamId: item.teamId, realName: item.name || item.realName, name: item.name || item.realName, avatar: item.avatar || '', deptName: item.deptName || '', highlight: [], id: item.id || item.userId + ":" + item.app + ":" + item.teamId, 
            // desc: item.desc || item.deptName ? `${item.unitName}-${item.deptName}-${item.titleName}` : '',
            desc: item.desc ||
                (item.deptName
                    ? getDeptPositionDesc({
                        deptName: (item === null || item === void 0 ? void 0 : item.deptName) || '',
                        titleName: (item === null || item === void 0 ? void 0 : item.titleName) || '',
                        unitName: item.unitName,
                        userType: item.userType,
                    })
                    : ''), titleName: item.titleName || '', labelInfoList: item.labelInfoList || [], unitName: item.unitName || '', deptId: item.deptId || '', unitDeptId: item.unitDeptId || '' });
        return obj;
    });
}
export function searchDataMapList(options) {
    var searchData = options.searchData, dataListFilter = options.dataListFilter, contactShowType = options.contactShowType, currentUser = options.currentUser, selectGroupType = options.selectGroupType;
    if (typeof searchData === 'string')
        return searchData;
    var contactsData = searchData.contacts.length
        ? selectContactTypeListItem(contactShowType, searchData.contacts, currentUser)
        : [];
    if (dataListFilter) {
        contactsData = contactsData.filter(dataListFilter);
    }
    var groupsData = searchData.groups.length
        ? selectGroupTypeListItem(selectGroupType, searchData.groups)
        : [];
    if (dataListFilter) {
        groupsData = groupsData.filter(dataListFilter);
    }
    var deptsData = searchData.depts.data.length ? searchData.depts.data : [];
    if (dataListFilter) {
        deptsData = deptsData.filter(dataListFilter);
    }
    var data = __assign(__assign({}, searchData), { contacts: contactsData, groups: groupsData, depts: {
            code: "0",
            data: deptsData,
        } });
    return data;
}
//# sourceMappingURL=common.js.map